import React, { useEffect, useState } from "react";
import "../../styles/components/ToolBarLeftPanel.scss";
import expandIcon from "../../images/expandIcon.svg";
import checkIcon from "../../images/CheckIcon.svg";
import checkMarkGreen from "../../images/ChecjmarkGreen.svg";
import AssociatedCard from "./AssociatedCard";
import Switch from "@mui/material/Switch";
import FormControlLabel from '@mui/material/FormControlLabel';
import expiredIcon from "../../images/expired status.svg";



const AssociatedModules = ({
  selectedModule,
  setSelectedModule,
  moduleClaimsData,
  sendAtomDetails2Canvas,
  isImageDropped,
  setIsImageDropped,
  setDataGraphichImgDropped,
  dataGraphichImgDropped,
  droppedComponentIds,
  setDroppedComponentIds,
  droppedTextIds,
  setDroppedTextIds,
  droppedTitleIds,
  setDroppedTitleIds,
  claimsArray,
  notUsedEditorToggle,
  setNotUsedEditorToggle,
  expandModule,
  setExpandModule,
  isReferenceFootnotes,
  reusableTextIdsArray,
}) => {
  const [expand, setExpand] = useState([]);
  const [currentModule, setCurrentModule] = useState(0);
  const [assignClicked, setAssignClicked] = useState(false)
  const [claimAssignClicked, setClaimAssignClicked] = useState(false);
const [componentAssignClicked, setComponentAssignClicked] = useState(false);
const [openQualifiersModal, setOpenQualifiersModal] = useState(false);
const [symbolChangeTick, setSymbolChangeTick] = useState(false);
const [selectedClaimIndex, setSelectedClaimIndex] = useState(0);
const [selectedRelatedClaimIndex, setSelectedRelatedClaimIndex] = useState({
  module: null,
  sub: null,
});
const [expandModuleQualifiers, setExpandModuleQualifiers] = useState(
  [true, false, false]
  );
  const [expandModuleGlobally, setExpandModuleGlobally] = useState(null);
  const [expandedParent,setExpandedParent] = useState("");
  const [expandedChild,setExpandedChild] = useState("");

  useEffect(() => {
    const anyExpanded = expandModule.some((item) => item === true);
    setExpand(anyExpanded);
  }, [expandModule]);

  useEffect(() => {
    setExpandModule([]);
    setExpand(false);
  }, [currentModule]);
  return (
    <>
      <div className="selected-module-window ">
        <div className="buissness-rule-div">
          <img
            src={expandIcon}
            onClick={() => {
              setSelectedModule(undefined);
              if (notUsedEditorToggle) {
                setNotUsedEditorToggle(false);
              }
            }}
            className="expandIcon"
          />
          <div style={{ paddingLeft: "7px" }} className="infoText">
            Module
          </div>
          <div style={{ paddingLeft: "4px" }}>:</div>
          <img src={moduleClaimsData?.mlrStatus === "Expired" ? expiredIcon : checkMarkGreen} className="check-mark-green" />
          <strong className="boldText">
            {selectedModule?.contentmoduleName ||
              selectedModule?.targetModuleDamName}
          </strong>
          <div className="d-flex notUsedEditorToggle">
            <div style={{ marginRight: "5px" }}>Not used in editor</div>
            <Switch
              checked={notUsedEditorToggle}
              onChange={(e) => {
                setNotUsedEditorToggle(!notUsedEditorToggle);
              }}
              style={{
                width: 26,
                height: 13,
                padding: 0,
                display: "flex",
                marginLeft: notUsedEditorToggle ? "-14px" : "-7px"
              }}
              classes={{
                track: notUsedEditorToggle ? "customSwitchTrack" : "",
              }}
            />
          </div>
        </div>
        <div className="note-text mb-3 mt-1">
          Note: All claims below are approved for use.
        </div>
        <div className="must-use-div mb-3">
          <div
            className="parentModulebox"
            style={{ backgroundColor: "#E32B35" }}
          ></div>
          <div className="rulesText">Must use</div>
          <div
            className="parentModulebox"
            style={{ backgroundColor: "#378A05", marginLeft: "12px" }}
          ></div>
          <div className="rulesText">Optional</div>
        </div>{" "}
        <div className="switch-section-div">
          <div
            className="section-change"
            style={{
              borderBottom: currentModule === 0 ? "2px solid #203662" : "",
              color: currentModule === 0 ? "#203662" : "#54565c",
              marginLeft: "0px",
              fontWeight: currentModule === 0 ? "600" : "",
            }}
            onClick={() => setCurrentModule(0)}
          >
            {`Claims (${moduleClaimsData?.claims?.length > 0
              ? moduleClaimsData?.claims?.length
              : 0
              })`}
          </div>
          <div
            className="section-change"
            style={{
              borderBottom: currentModule === 1 ? "2px solid #203662" : "",
              color: currentModule === 1 ? "#203662" : "#54565c",
              fontWeight: currentModule === 1 ? "600" : "",
            }}
            onClick={() => setCurrentModule(1)}
          >
            {`Reusable Text(${moduleClaimsData?.reusableTexts?.length > 0
              ? moduleClaimsData?.reusableTexts?.length
              : 0
              })`}
          </div>
          <div
            className="section-change"
            style={{
              borderBottom: currentModule === 2 ? "2px solid #203662" : "",
              color: currentModule === 2 ? "#203662" : "#54565c",
              fontWeight: currentModule === 2 ? "600" : "",
            }}
            onClick={() => setCurrentModule(2)}
          >
            {`Component (${moduleClaimsData?.components?.length > 0
              ? moduleClaimsData?.components?.length
              : 0
              })`}
          </div>
        </div>
        <div
          style={{
            width: "100%",
            backgroundColor: "#DDDFDD",
            height: "0.5px",
          }}
        ></div>
        <div className="custonScrollBar modulesCliamsection">
          {currentModule === 0 && (
            <>
              {(moduleClaimsData?.claims?.length > 0) ?
                (
                  <>
                    {moduleClaimsData?.claims?.map((claim, index) => {
                        const accordionId = `claim-${0}${index}`
                      return (
                        <AssociatedCard
                          setExpandModuleGlobally={setExpandModuleGlobally}
                          expandModuleGlobally={expandModuleGlobally}
                          key={accordionId}
                        accordionId={accordionId}
                          selectedClaimIndex={selectedClaimIndex}
                          setSelectedClaimIndex={setSelectedClaimIndex}
                          selectedRelatedClaimIndex={selectedRelatedClaimIndex}
                          setSelectedRelatedClaimIndex={setSelectedRelatedClaimIndex}
                          expandModuleQualifiers={expandModuleQualifiers}
                          setExpandModuleQualifiers={setExpandModuleQualifiers}
                          openQualifiersModal={openQualifiersModal}
                          setOpenQualifiersModal={setOpenQualifiersModal}
                          length={moduleClaimsData?.claims?.length}
                          isReferenceFootnotes={isReferenceFootnotes}
                          claimsArray={claimsArray}
                          setDataGraphichImgDropped={setDataGraphichImgDropped}
                          dataGraphichImgDropped={dataGraphichImgDropped}
                          modulesArray={moduleClaimsData?.claims}
                          claim={claim}
                          expandModule={expandModule}
                          setExpandModule={setExpandModule}
                          sendAtomDetails2Canvas={sendAtomDetails2Canvas}
                          index={index}
                          notUsedEditorToggle={notUsedEditorToggle}
                          setClaimAssignClicked={setClaimAssignClicked}
                          claimAssignClicked={claimAssignClicked}
                          assignClicked={assignClicked}
                          setExpandedParent={setExpandedParent}
                          expandedParent={expandedParent}
                          setExpandedChild={setExpandedChild}
                          expandedChild={expandedChild}
                          currentModuleIdentifier={moduleClaimsData.moduleDamName}
                        />

                      );
                    })}
                  </>
                )
                : (
                  notUsedEditorToggle && (
                    <div className="claimUsedIconContainer">
                      <img src={checkIcon} style={{ height: "36px" }} />
                      <div className="allClaimsUsedText">All claims are used in the Editor.</div>
                    </div>
                  )
                )
              }
            </>
          )}
          {currentModule === 1 && (
            <>
              {(moduleClaimsData?.reusableTexts?.length > 0) ?
                (
                  <>
                    {moduleClaimsData?.reusableTexts?.map((reusableText, index) => {
                        const accordionId = `rts-${1}${index}`
                      return (
                        <AssociatedCard
                        isReferenceFootnotes={isReferenceFootnotes}
                        setExpandModuleGlobally={setExpandModuleGlobally}
                        expandModuleGlobally={expandModuleGlobally}
                        key={accordionId}
                        accordionId={accordionId}
                          setOpenQualifiersModal={setOpenQualifiersModal}
                          length={moduleClaimsData?.reusableTexts?.length}
                          reusableTextIdsArray={reusableTextIdsArray}
                          modulesArray={moduleClaimsData?.reusableTexts}
                          reusableText={reusableText}
                          expandModule={expandModule}
                          setExpandModule={setExpandModule}
                          sendAtomDetails2Canvas={sendAtomDetails2Canvas}
                          index={index}
                          dataGraphichImgDropped={dataGraphichImgDropped}
                          setDataGraphichImgDropped={setDataGraphichImgDropped}
                          notUsedEditorToggle={notUsedEditorToggle}
                          // setAssignClicked={setAssignClicked}
                          // assignClicked={assignClicked}
                          setExpandedParent={setExpandedParent}
                          expandedParent={expandedParent}
                          setExpandedChild={setExpandedChild}
                          expandedChild={expandedChild}
                          currentModuleIdentifier={moduleClaimsData.moduleDamName}
                        />
                      );
                    })}
                  </>
                )
                : (
                  notUsedEditorToggle && (
                    <div className="claimUsedIconContainer">
                      <img src={checkIcon} style={{ height: "36px" }} />
                      <div className="allClaimsUsedText">All Reusable Texts are used in the Editor.</div>
                    </div>
                  )
                )
              }
            </>
          )}
          {currentModule === 2 && (
            <>
              {(moduleClaimsData?.components?.length > 0) ?
                (
                  <>
                    {moduleClaimsData?.components?.map((component, index) => {
                       const accordionId = `component-${2}${index}`
                      return (
                        <AssociatedCard
                        isReferenceFootnotes={isReferenceFootnotes}
                        setExpandModuleGlobally={setExpandModuleGlobally}
                        expandModuleGlobally={expandModuleGlobally}
                        key={accordionId}
                        accordionId={accordionId}
                        selectedClaimIndex={selectedClaimIndex}
                        setSelectedClaimIndex={setSelectedClaimIndex}
                        selectedRelatedClaimIndex={selectedRelatedClaimIndex}
                        setSelectedRelatedClaimIndex={setSelectedRelatedClaimIndex}
                        expandModuleQualifiers={expandModuleQualifiers}
                        setExpandModuleQualifiers={setExpandModuleQualifiers}
                        openQualifiersModal={openQualifiersModal}
                          setOpenQualifiersModal={setOpenQualifiersModal}
                          length={moduleClaimsData?.components?.length}
                          setDroppedTextIds={setDroppedTextIds}
                          droppedTextIds={droppedTextIds}
                          droppedComponentIds={droppedComponentIds}
                          droppedTitleIds={droppedTitleIds}
                          setDroppedTitleIds={setDroppedTitleIds}
                          setDroppedComponentIds={setDroppedComponentIds}
                          modulesArray={moduleClaimsData?.components}
                          component={component}
                          expandModule={expandModule}
                          setExpandModule={setExpandModule}
                          sendAtomDetails2Canvas={sendAtomDetails2Canvas}
                          index={index}
                          isImageDropped={isImageDropped}
                          setIsImageDropped={setIsImageDropped}
                          setDataGraphichImgDropped={setDataGraphichImgDropped}
                          dataGraphichImgDropped={dataGraphichImgDropped}
                          notUsedEditorToggle={notUsedEditorToggle}
                          setComponentAssignClicked={setComponentAssignClicked}
                          componentAssignClicked={componentAssignClicked}
                          setExpandedParent={setExpandedParent}
                          expandedParent={expandedParent}
                          setExpandedChild={setExpandedChild}
                          expandedChild={expandedChild}
                          currentModuleIdentifier={moduleClaimsData.moduleDamName}
                        />
                      );
                    })}
                  </>
                )
                : (
                  notUsedEditorToggle && (
                    <div className="claimUsedIconContainer">
                      <img src={checkIcon} style={{ height: "36px" }} />
                      <div className="allClaimsUsedText">All Components are used in the Editor.</div>
                    </div>
                  )
                )
              }
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default AssociatedModules;
